import { defineStore } from 'pinia'
import { getTeam } from '@/modules/database/teams'

interface TeamData {
  teams: Team[]
  activeTeam: Team
}

export const useTeamStore = defineStore('team', {
  state: (): TeamData => ({
    teams: [],
    activeTeam: {
      name: '',
      id: '',
      adminIds: [],
      memberIds: [],
      coachIds: [],
      savedLocations: []
    }
  }),
  getters: {
    getRoleById: (state) => (userId: string) => {
      if (state.activeTeam.adminIds.includes(userId)) {
        return 'admin'
      } else if (state.activeTeam.coachIds.includes(userId)) {
        return 'coach'
      } else if (state.activeTeam.memberIds.includes(userId)) {
        return 'member'
      }

      return 'visitor'
    }
  },
  actions: {
    async getTeam(teamId: string) {
      const teamData = await getTeam(teamId)
      this.$patch({ activeTeam: teamData })
    }
  }
})
